import { Injectable } from '@angular/core';

export class RfqPreview {
  supplierLevers: any = [];
  supplierByView: any = [];
  rawSupplierList: any = [];
}
